
interface HeaderProps {
	workspace?: any | null
	size?: number
	src?: string | null
	name?: string | null
}

export const NewWorkspaceAvatar = ({
	workspace,
	size,
	src,
	name
}: HeaderProps) => {
	return (
		<img
			className={`inline-block h-${size || 10} w-${
				size || 10
			} rounded-full border border-t-profile-border bg-white`}
			src={
				src ||
				workspace?.avatar ||
				`https://eu.ui-avatars.com/api/?name=${
					(workspace?.name && workspace?.name[0]) || name
				}&background=${'F3F4F6'}&color=${'343741'}`
			}
			alt="workspace icon"
			onError={(e) =>
				(e.currentTarget.src = `https://eu.ui-avatars.com/api/?name=${
					(workspace?.name && workspace?.name[0]) || name
				}&background=${'F3F4F6'}&color=${'343741'}`)
			}
		/>
	)
}
